import { QuestionDataComponent } from './components/question-data/question-data.component';
import { QuestionTextComponent } from './components/question-text/question-text.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  AccessDeniedComponent,
  AuthGuard,
  LoginComponent,
  MANAGEMENT_APPLICATIONS_ROLES,
  MANAGEMENT_HOME_ROLES,
  SsoCallbackComponent
} from '@aacr/shared';
import { HomeComponent } from './home/home.component';
import { ApplicationsComponent } from './components/applications/applications.component';
import { ApplicationDetailsComponent } from './components/application-details/application-details.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'sso/callback',
    component: SsoCallbackComponent
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
    canActivate: [AuthGuard]
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard],
    data: { roles: MANAGEMENT_HOME_ROLES }
  },
  {
    path: 'applications',
    component: ApplicationsComponent,
    canActivate: [AuthGuard],
    data: { roles: MANAGEMENT_APPLICATIONS_ROLES, deniedRedirect: '/home' }
  },
  {
    path: 'application-details/:id',
    component: ApplicationDetailsComponent,
    canActivate: [AuthGuard],
    data: { roles: MANAGEMENT_APPLICATIONS_ROLES, deniedRedirect: '/home' }
  },
  {
    path: 'application-details',
    component: ApplicationDetailsComponent,
    canActivate: [AuthGuard],
    data: { roles: MANAGEMENT_APPLICATIONS_ROLES, deniedRedirect: '/home' }
  },
  {
    path: 'question-data',
    component: QuestionDataComponent,
    canActivate: [AuthGuard],
    data: { roles: MANAGEMENT_HOME_ROLES }
  },
  {
    path: 'question-text',
    component: QuestionTextComponent,
    canActivate: [AuthGuard],
    data: { roles: MANAGEMENT_HOME_ROLES }
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
